import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

export const jingleUrl = 'jingle'

export interface JingleModel extends DjangoModel {
  audioId: EntityId
  description: string
  name: string
}

const {
  slice: jingleSlice,
  thunks: jingleThunks,
  adapter: jingleAdapter,
  selectors,
} = createGenericSlice<JingleModel>(
  'jingle',
  jingleUrl,
  {}
  //jingleExtraReducers  Initial state can be customized if needed
)

// export const jingleAdapterExport = jingleAdapter

export const { fetchAll: fetchAllJingles } = jingleThunks
export const { selectAll: selectAllJingles, selectById: selectJingleById } =
  jingleAdapter.getSelectors<RootState>((state: RootState) => state.jingle)
export const {
  selectLoading: selectJingleLoading,
  selectIsIdInProgress: selectIsJingleIdInProgress,
  selectError: selectJingleError,
} = selectors

export default jingleSlice.reducer
